/** Pure scroll math (testable without Phaser). */

export function clampScroll(scrollY: number, scrollMax: number): number {
  if (!Number.isFinite(scrollY)) return 0;
  const max = Math.max(0, Number.isFinite(scrollMax) ? scrollMax : 0);
  if (scrollY < 0) return 0;
  if (scrollY > max) return max;
  return scrollY;
}

export function npcDialogContainerY(args: {
  viewportY: number;
  scrollY: number;
  scrollMax: number;
}): number {
  const clamped = clampScroll(args.scrollY, args.scrollMax);
  return args.viewportY - clamped;
}

export function scrollMaxForContent(contentH: number, viewportH: number): number {
  return Math.max(0, contentH - viewportH);
}

/** scrollY that keeps the bottom of a line (container-local Y) visible in the viewport. */
export function scrollYForLineBottom(
  lineBottomLocal: number,
  viewportH: number,
  scrollMax: number,
  padding = 8
): number {
  const target = lineBottomLocal - viewportH + padding;
  return clampScroll(target, scrollMax);
}

export function lerpScrollY(current: number, target: number, factor: number): number {
  const next = current + (target - current) * factor;
  return Math.abs(next - target) < 0.75 ? target : next;
}
